import { render, staticRenderFns } from "./FacebookLoginIcon.vue?vue&type=template&id=a13b0c00"
import script from "./FacebookLoginIcon.vue?vue&type=script&lang=js"
export * from "./FacebookLoginIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports